import { UserListModal } from '@/components/UserListModal';
import { useMCPServerUsers } from '@/hooks/api/useMCPServers';
import type { UseQueryResult } from '@tanstack/react-query';
import { COLUMNS, type UserUsage } from './constants';
interface MCPUsageUserListProps {
  organizationId: string;
  serverName: string;
  onClose: () => void;
  open: boolean;
}

export const MCPUsageUserList = ({
  organizationId,
  serverName,
  onClose,
  open,
}: MCPUsageUserListProps) => {
  const rawQuery = useMCPServerUsers(
    organizationId,
    serverName || '',
    !!organizationId && !!serverName && open,
    {
      // Narrow the React Query result to just the users array
      // Typescript infers the base data type; we only assert the
      // selected value type here for the UserListModal.
      select: data => (data?.users ?? []) as unknown as UserUsage[],
    }
  );

  const query = rawQuery as unknown as UseQueryResult<UserUsage[]>;

  return (
    <UserListModal<UserUsage>
      open={open}
      title={
        <>
          Users with <span className="font-mono">{serverName}</span>
        </>
      }
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
      query={query}
      columns={COLUMNS}
    />
  );
};
